// Type definition for data points used in charts
interface DataPoint {
    x: number;
    y: number;
}

// Type definition for Risk Zone object
export interface RiskZoneResult {
    riskZone: number;
    percentileString: string;
    explanation: string;
}

// Type definition for Phototherapy result
export interface PhototherapyResult {
    shouldUse: boolean;
    delta: number; // Using number instead of string for delta
}


// Data points converted to TypeScript constants
export const percentile40DataPoints: DataPoint[] = [
    { x: 12, y: 4.0 }, { x: 16, y: 4.4 }, { x: 20, y: 4.7 }, { x: 24, y: 4.9 }, { x: 28, y: 5.5 },
    { x: 32, y: 6.3 }, { x: 36, y: 7.0 }, { x: 40, y: 7.7 }, { x: 44, y: 8.2 }, { x: 48, y: 8.6 },
    { x: 52, y: 9.0 }, { x: 56, y: 9.3 }, { x: 60, y: 9.6 }, { x: 64, y: 10.2 }, { x: 68, y: 10.7 },
    { x: 72, y: 11.2 }, { x: 76, y: 11.3 }, { x: 80, y: 11.4 }, { x: 84, y: 11.6 }, { x: 88, y: 11.8 },
    { x: 92, y: 12.2 }, { x: 96, y: 12.3 }, { x: 100, y: 12.5 }, { x: 104, y: 12.7 }, { x: 108, y: 12.8 },
    { x: 112, y: 13.0 }, { x: 116, y: 13.1 }, { x: 120, y: 13.2 }, { x: 124, y: 13.2 }, { x: 128, y: 13.2 },
    { x: 132, y: 13.2 }, { x: 136, y: 13.2 }, { x: 140, y: 13.2 }, { x: 144, y: 13.2 }, { x: 148, y: 13.2 }
];

export const percentile75DataPoints: DataPoint[] = [
    { x: 12, y: 5.0 }, { x: 16, y: 5.5 }, { x: 20, y: 5.9 }, { x: 24, y: 6.1 }, { x: 28, y: 7.0 },
    { x: 32, y: 8.0 }, { x: 36, y: 8.9 }, { x: 40, y: 9.9 }, { x: 44, y: 10.3 }, { x: 48, y: 10.8 },
    { x: 52, y: 11.3 }, { x: 56, y: 12.0 }, { x: 60, y: 12.6 }, { x: 64, y: 12.9 }, { x: 68, y: 13.1 },
    { x: 72, y: 13.4 }, { x: 76, y: 13.8 }, { x: 80, y: 14.3 }, { x: 84, y: 14.7 }, { x: 88, y: 14.7 },
    { x: 92, y: 15.0 }, { x: 96, y: 15.2 }, { x: 100, y: 15.3 }, { x: 104, y: 15.4 }, { x: 108, y: 15.5 },
    { x: 112, y: 15.6 }, { x: 116, y: 15.7 }, { x: 120, y: 15.8 }, { x: 124, y: 15.7 }, { x: 128, y: 15.6 },
    { x: 132, y: 15.5 }, { x: 136, y: 15.4 }, { x: 140, y: 15.3 }, { x: 144, y: 15.2 }, { x: 148, y: 15.3}
];

export const percentile95DataPoints: DataPoint[] = [
    { x: 12, y: 7.0 }, { x: 16, y: 7.2 }, { x: 20, y: 7.4 }, { x: 24, y: 7.8 }, { x: 28, y: 8.9 },
    { x: 32, y: 10.0 }, { x: 36, y: 11.1 }, { x: 40, y: 12.2 }, { x: 44, y: 12.5 }, { x: 48, y: 13.2 },
    { x: 52, y: 13.8 }, { x: 56, y: 14.4 }, { x: 60, y: 15.2 }, { x: 64, y: 15.4 }, { x: 68, y: 15.6 },
    { x: 72, y: 15.9 }, { x: 76, y: 16.2 }, { x: 80, y: 16.4 }, { x: 84, y: 16.7 }, { x: 88, y: 17.0 },
    { x: 92, y: 17.2 }, { x: 96, y: 17.4 }, { x: 100, y: 17.4 }, { x: 104, y: 17.5 }, { x: 108, y: 17.5 },
    { x: 112, y: 17.5 }, { x: 116, y: 17.6 }, { x: 120, y: 17.7 }, { x: 124, y: 17.6 }, { x: 128, y: 17.5 },
    { x: 132, y: 17.4 }, { x: 136, y: 17.4 }, { x: 140, y: 17.3 }, { x: 144, y: 17.3 }, { x: 148, y: 17.4 }
];

export const transfusionWeek38PlusNoRisk: DataPoint[] = [
    { x: 5.9,  y: 16.1 }, { x: 9.1,  y: 16.5 }, { x: 11,   y: 16.8 }, { x: 14.5, y: 17.2 }, { x: 17.3, y: 17.5 },
    { x: 22.2, y: 18 }, { x: 24.4, y: 18.4 }, { x: 26.6, y: 18.6 }, { x: 30.2, y: 19.1 }, { x: 33.8, y: 19.6 },
    { x: 37.3, y: 20.1 }, { x: 40.9, y: 20.6 }, { x: 44.7, y: 21 }, { x: 47.5, y: 21.3 }, { x: 50,   y: 21.7 },
    { x: 54.1, y: 22.1 }, { x: 57.1, y: 22.3 }, { x: 61.2, y: 22.7 }, { x: 63.4, y: 22.9 }, { x: 65.9, y: 23.1 },
    { x: 69.2, y: 23.3 }, { x: 73.8, y: 23.6 }, { x: 77.7, y: 24 }, { x: 80.2, y: 24.1 }, { x: 82.4, y: 24.1 },
    { x: 86.7, y: 24.4 }, { x: 89.8, y: 24.6 }, { x: 94.7, y: 24.8 }, { x: 98.8, y: 24.9 }, { x: 103.5, y: 25.1 },
    { x: 107.3, y: 25.1 }, { x: 111.5, y: 25.1 }, { x: 115.8, y: 25.1 }, { x: 120,   y: 25.1 }, { x: 124.9, y: 25.1 },
    { x: 128.2, y: 25.1 }, { x: 133.4, y: 25.1 }, { x: 137,   y: 25.1 }, { x: 141.9, y: 25.1 }, { x: 145.2, y: 25.1 },
    { x: 149.9, y: 25 }, { x: 153.5, y: 25.1 }, { x: 158.7, y: 25.1 }, { x: 163.1, y: 25.1 }, { x: 167,   y: 25.1 },
];

export const transfusionWeek38PlusWithRisk: DataPoint[] = [
    { x: 6.2,  y: 14 }, { x: 10.7, y: 14.6 }, { x: 15.1, y: 15 }, { x: 19,   y: 15.4 }, { x: 22.3, y: 15.9 },
    { x: 24.7, y: 16.2 }, { x: 26.7, y: 16.4 }, { x: 30.2, y: 16.8 }, { x: 33.8, y: 17.2 }, { x: 37.7, y: 17.6 },
    { x: 42.3, y: 18 }, { x: 45.6, y: 18.3 }, { x: 49.2, y: 18.6 }, { x: 52.2, y: 18.9 }, { x: 56.4, y: 19.2 },
    { x: 60.8, y: 19.6 }, { x: 65.4, y: 20 }, { x: 69.6, y: 20.4 }, { x: 73.7, y: 20.7 }, { x: 77.3, y: 21 },
    { x: 81.7, y: 21.3 }, { x: 85.8, y: 21.7 }, { x: 90.2, y: 22 }, { x: 94,    y: 22.2 }, { x: 98.7,  y: 22.4 },
    { x: 102.8, y: 22.5 }, { x: 107.2, y: 22.6 }, { x: 112.5, y: 22.6 }, { x: 118,   y: 22.6 }, { x: 122.9, y: 22.6 },
    { x: 126.8, y: 22.6 }, { x: 132.3, y: 22.6 }, { x: 138,   y: 22.6 }, { x: 143,   y: 22.6 }, { x: 147.7, y: 22.6 },
    { x: 153.2, y: 22.6 }, { x: 159.2, y: 22.6 }, { x: 164.2, y: 22.6 }, { x: 167.6, y: 22.6 }
];

export const transfusionWeek37NoRisk: DataPoint[] = [
    { x: 6.1,  y: 14 }, { x: 10.2, y: 14.5 }, { x: 15,   y: 14.8 }, { x: 18.7, y: 15.2 }, { x: 22.7, y: 15.6 },
    { x: 24.9, y: 16 }, { x: 27.2, y: 16.2 }, { x: 30,   y: 16.7 }, { x: 33.7, y: 17.1 }, { x: 37.7, y: 17.5 },
    { x: 39.7, y: 17.8 }, { x: 42.2, y: 18 }, { x: 46.2, y: 18.3 }, { x: 49.6, y: 18.7 }, { x: 54.4, y: 19 },
    { x: 57.8, y: 19.3 }, { x: 62.3, y: 19.9 }, { x: 65.2, y: 20.3 }, { x: 69.7, y: 20.8 }, { x: 72.8, y: 21.2 },
    { x: 77.9, y: 21.8 }, { x: 81.3, y: 21.9 }, { x: 85.8, y: 22.2 }, { x: 88.1, y: 22.3 }, { x: 90.4, y: 22.5 },
    { x: 94.6, y: 22.7 }, { x: 97.2, y: 22.8 }, { x: 99.2, y: 22.8 }, { x: 103.1, y: 22.9}, { x: 107.1, y: 23 },
    { x: 111.3, y: 23 }, { x: 116.2, y: 23 }, { x: 119.8, y: 23 }, { x: 123.2, y: 23}, { x: 129.5, y: 22.9 },
    { x: 132.6, y: 22.9 }, { x: 137.7, y: 22.9 }, { x: 141.7, y: 22.9 }, { x: 146.2, y: 23 }, { x: 150.2, y: 23 },
    { x: 155, y: 22.9 }, { x: 158.4,y: 22.9 }, { x: 164,y: 22.9 }, { x: 166.7, y: 22.9}
];

export const transfusionWeek37WithRisk: DataPoint[] = [
    { x: 6.4,  y: 12 }, { x: 9.9,  y: 12.3 }, { x: 13.3, y: 12.7 }, { x: 17,   y: 13 }, { x: 21,   y: 13.4 },
    { x: 24.9, y: 13.9 }, { x: 29.2, y: 14.4 }, { x: 33.1, y: 14.9 }, { x: 37.1, y: 15.4 }, { x: 40.5, y: 15.9 },
    { x: 44.2, y: 16.2 }, { x: 48.7, y: 16.6 }, { x: 52.7, y: 16.9 }, { x: 57.5, y: 17.3 }, { x: 62.3, y: 17.7 },
    { x: 66.9, y: 18 }, { x: 72,   y: 18.5 }, { x: 77.6, y: 18.9 }, { x: 82.2, y: 19.1 }, { x: 86.1, y: 19.3 },
    { x: 90.7, y: 19.5 }, { x: 96,   y: 19.5 }, { x: 99.4, y: 19.5 }, { x: 102.8, y: 19.5 }, { x: 107.9, y: 19.5 },
    { x: 113.9, y: 19.5 }, { x: 118.4, y: 19.5 }, { x: 123,   y: 19.5 }, { x: 127.5, y: 19.5 }, { x: 132.3, y: 19.5 },
    { x: 138.3, y: 19.5 }, { x: 143.6, y: 19.5 }, { x: 149.6, y: 19.5 }, { x: 155.8, y: 19.5 }, { x: 161.5, y: 19.5 },
    { x: 166.4, y: 19.5 }
];

export const phototherapyIsraeliProtocolWeek38PlusNoRisk: DataPoint[] = [
    { x: 5.8,  y: 7.2 }, { x: 10.4, y: 7.9 }, { x: 12.0, y: 8.0 }, { x: 13.2, y: 8.4 }, { x: 17.2, y: 9.1 },
    { x: 20.4, y: 9.7 }, { x: 23.9, y: 10.3 }, { x: 26.7, y: 10.9 }, { x: 30.7, y: 11.7 }, { x: 33.9, y: 12.3 },
    { x: 37.1, y: 12.9 }, { x: 40.7, y: 13.4 }, { x: 45.1, y: 14 }, { x: 48.3, y: 14.5 }, { x: 52.7, y: 15 },
    { x: 55.9, y: 15.4 }, { x: 60.3, y: 16.1 }, { x: 63.8, y: 16.5 }, { x: 67.4, y: 16.8 }, { x: 71.8, y: 17.3 },
    { x: 75,   y: 17.6 }, { x: 79,   y: 18 }, { x: 83.4, y: 18.5 }, { x: 87.8, y: 19 }, { x: 91.4, y: 19.3 },
    { x: 96.2, y: 19.5 }, { x: 100.2, y: 19.9 }, { x: 104.2, y: 20.1 }, { x: 108.5, y: 20.4 }, { x: 112.1, y: 20.6 },
    { x: 116.9, y: 20.8 }, { x: 120.9, y: 21 }, { x: 124.9, y: 21.2 }, { x: 129.3, y: 21.3 }, { x: 133.7, y: 21.2 },
    { x: 138.5, y: 21.2 }, { x: 142.5, y: 21.2 }, { x: 146.9, y: 21.2 }, { x: 150.4, y: 21.2 }, { x: 155.2, y: 21.2 },
    { x: 158.8, y: 21.2 }, { x: 163.6, y: 21.2 }, { x: 168, y: 21.2 }
];

export const phototherapyIsraeliProtocolWeek38PlusWithRisk: DataPoint[] = [
    { x: 5.8, y: 5.2 }, { x: 10,  y: 5.9 }, { x: 13.6,y: 6.8 }, { x: 17.2,y: 7.6 }, { x: 20.8,y: 8.1 },
    { x: 24.3,y: 8.8 }, { x: 28.7,y: 9.4 }, { x: 32.7,y: 10 }, { x: 37.5,y: 10.8 }, { x: 41.1,y: 11.4 },
    { x: 45.1,y: 12 }, { x: 51.1,y: 12.8 }, { x: 56.7,y: 13.4 }, { x: 61.9,y: 14.1 }, { x: 66.6,y: 14.7 },
    { x: 72.6,y: 15.1 }, { x: 77.4,y: 15.5 }, { x: 84.2,y: 16.1 }, { x: 90.6,y: 16.6 }, { x: 96.6,y: 16.9 },
    { x: 102.6,y: 17.3 }, { x: 107.7,y: 17.6 }, { x: 114.1,y: 17.9 }, { x: 120.5,y: 18 }, { x: 126.1,y: 18.1 },
    { x: 130.9,y: 18.1 }, { x: 137.3,y: 18.1 }, { x: 143.3,y: 18.1 }, { x: 148.4,y: 18.1 }, { x: 154.4,y: 18.1 },
    { x: 160,  y: 18.1 }, { x: 166.6,y: 18.1 }, { x: 168,  y: 18.1 }
];

export const phototherapyIsraeliProtocolWeek37NoRisk: DataPoint[] = [
    { x: 6,  y: 5 }, { x: 6.2,  y: 5.1 }, { x: 10,   y: 6 }, { x: 12.4, y: 6.5 }, { x: 16,   y: 7.3 },
    { x: 19.6, y: 8.1 }, { x: 23.5, y: 8.6 }, { x: 26.7, y: 9.4 }, { x: 29.5, y: 9.9 }, { x: 33.1, y: 10.4 },
    { x: 36.7, y: 11 }, { x: 39.9, y: 11.5 }, { x: 43.9, y: 12.1 }, { x: 48.3, y: 12.5 }, { x: 52.3, y: 12.9 },
    { x: 55.9, y: 13.3 }, { x: 59.9, y: 13.9 }, { x: 63.4, y: 14.4 }, { x: 67.8, y: 14.7 }, { x: 71.8, y: 15 },
    { x: 75.4, y: 15.4 }, { x: 79.8, y: 15.8 }, { x: 84.2, y: 16.1 }, { x: 87.8, y: 16.5 }, { x: 92.2, y: 16.8 },
    { x: 96.2, y: 17.2 }, { x: 100.2, y: 17.5 }, { x: 104.6, y: 17.8 }, { x: 108.9, y: 17.9 }, { x: 113.3, y: 18 },
    { x: 117.3, y: 18 }, { x: 121.7, y: 18.1 }, { x: 126.1, y: 18.1 }, { x: 130.5, y: 18.1 }, { x: 134.9, y: 18.1 },
    { x: 138.9, y: 18.1 }, { x: 142.9, y: 18.1 }, { x: 147.2, y: 18.1 }, { x: 151.6, y: 18.1 }, { x: 155.6, y: 18.1 },
    { x: 160,   y: 18.1 }, { x: 167.4, y: 18.1 }, { x: 168, y: 18.1 }
];

export const phototherapyIsraeliProtocolWeek37WithRisk: DataPoint[] = [
    { x: 6,  y: 4 }, { x: 6.2,  y: 4.2 }, { x: 10.8, y: 4.9 }, { x: 16.4, y: 5.9 }, { x: 21.9, y: 6.7 },
    { x: 27.1, y: 7.5 }, { x: 31.9, y: 8.1 }, { x: 37.1, y: 8.9 }, { x: 43.1, y: 9.7 }, { x: 48.3, y: 10.4 },
    { x: 54.7, y: 11.2 }, { x: 61.9, y: 12.1 }, { x: 65.8, y: 12.6 }, { x: 71.8, y: 13.1 }, { x: 78.2, y: 13.6 },
    { x: 86.6, y: 14 }, { x: 93.8, y: 14.3 }, { x: 100.6, y: 14.6 }, { x: 108.1, y: 14.8 }, { x: 113.7, y: 15 },
    { x: 119.7, y: 15 }, { x: 126.1, y: 15 }, { x: 134.5, y: 15 }, { x: 142.1, y: 15 }, { x: 150.8, y: 15 },
    { x: 158,   y: 15 }, { x: 163.2, y: 15 }, { x: 167.4, y: 15 }, { x: 168, y: 15 }
];

// Helper function to get case index
export function getGenericCaseIndex(isWeek38Plus: boolean, hasRisk: boolean): number {
    if (isWeek38Plus) {
        return hasRisk ? 1 : 0;
    } else {
        return hasRisk ? 3 : 2;
    }
}

export const allphototherapyDataPoints: DataPoint[][] = [
    phototherapyIsraeliProtocolWeek38PlusNoRisk,
    phototherapyIsraeliProtocolWeek38PlusWithRisk,
    phototherapyIsraeliProtocolWeek37NoRisk,
    phototherapyIsraeliProtocolWeek37WithRisk
];

export const alltransfusionDataPoints: DataPoint[][] = [
    transfusionWeek38PlusNoRisk,
    transfusionWeek38PlusWithRisk,
    transfusionWeek37NoRisk,
    transfusionWeek37WithRisk
];

export const phototherapyChartsTitleSuffix: string[] = [
    '38+ ללא גורמי סיכון', '38+ עם גורמי סיכון', '35-37 ללא גורמי סיכון', '35-37 עם גורמי סיכון'
];

// Helper function to create labels and values for Butani chart
function createLabelsAndValues(datapoints: DataPoint[]): [number[], (number | null)[]] {
    const labels: number[] = [];
    const values: (number | null)[] = [];
    labels.push(0);
    values.push(null); // Use null for NaN to match Chart.js expectations
    for (let i = 0; i < datapoints.length; ++i) {
        labels.push(datapoints[i].x);
        values.push(datapoints[i].y);
    }
    return [labels, values];
}

const percentile40LabelsValues = createLabelsAndValues(percentile40DataPoints);
const percentile75LabelsValues = createLabelsAndValues(percentile75DataPoints);
const percentile95LabelsValues = createLabelsAndValues(percentile95DataPoints);

// Butani Chart Data Structure
export const butaniData = {
    labels: percentile40LabelsValues[0],
    datasets: [
        {
            data: percentile95LabelsValues[1],
            borderColor: 'black',
            // fill: false, // fill is optional
            label: 'אחוזון 95',
            cubicInterpolationMode: 'monotone' as const,
            tension: 0.4,
            pointRadius: 0 // Hide points
        },
        {
            data: percentile75LabelsValues[1],
            borderColor: '#7e7e7e',
            // fill: false,
            label: 'אחוזון 75',
            cubicInterpolationMode: 'monotone' as const,
            tension: 0.4,
            pointRadius: 0 // Hide points
        },
        {
            data: percentile40LabelsValues[1],
            borderColor: '#d1d1d1',
            // fill: false,
            label: 'אחוזון 40',
            cubicInterpolationMode: 'monotone' as const,
            tension: 0.4,
            pointRadius: 0 // Hide points
        }
    ]
};


// Function to get phototherapy data points based on case
export function getPhototherapyDataPointsByCase(isWeek38Plus: boolean, hasRisk: boolean): DataPoint[] {
    const index = getGenericCaseIndex(isWeek38Plus, hasRisk);
    return allphototherapyDataPoints[index];
}

// Function to get transfusion data points based on case
export function getTransfusionDataPointsByCase(isWeek38Plus: boolean, hasRisk: boolean): DataPoint[] {
    const index = getGenericCaseIndex(isWeek38Plus, hasRisk);
    return alltransfusionDataPoints[index];
}

// Function to prepare data for the phototherapy chart
export function getPhototherapyData(is38Plus: boolean, hasRiskFactors: boolean) {
    const phototherapyDataPoints = getPhototherapyDataPointsByCase(is38Plus, hasRiskFactors);
    const transfusionDataPoints = getTransfusionDataPointsByCase(is38Plus, hasRiskFactors);
    return {
        datasets: [
            {
                data: phototherapyDataPoints,
                borderColor: 'black',
                // fill: false,
                label: 'פוטותרפיה',
                cubicInterpolationMode: 'monotone' as const,
                tension: 0.4,
                pointRadius: 0,
                borderDash: [0, 0]
            },
            {
                data: transfusionDataPoints,
                borderColor: 'red',
                // fill: false,
                label: 'החלפת דם',
                cubicInterpolationMode: 'monotone' as const,
                tension: 0.4,
                pointRadius: 0,
                borderDash: [0, 0]
            }
        ]
    };
}

// Interpolation function
function interpolate(x0: number, y0: number, x1: number, y1: number, x: number): number {
    // Handle cases where points might be undefined or null if data is sparse
    if (y0 === null || y1 === null) return NaN;
    return y0 + ((y1 - y0) / (x1 - x0)) * (x - x0);
}

// Function to get Y value on a curve for a given X
export function getYOnCurveByX(dataPoints: DataPoint[], x: number): number {
    if (!dataPoints || dataPoints.length === 0) return NaN;

    // Avoid interpolate on X > defined range function.
    const maxDefinedX = dataPoints[dataPoints.length - 1].x;
    if (x > maxDefinedX) {
        x = maxDefinedX;
    }
     // Handle X < minimum defined X
    const minDefinedX = dataPoints[0].x;
     if (x < minDefinedX) {
        // Decide how to handle this: return NaN, extrapolate, or return the first y-value?
        // Returning NaN seems safest if the curve isn't defined below this point.
        return NaN;
     }


    // Find the two points between which the X coordinate lies
    let i = 0;
    // Ensure dataPoints[i+1] exists before accessing .x
    while (i < dataPoints.length - 1 && dataPoints[i + 1].x < x) {
        i++;
    }

    // Check if points exist before interpolation
    if (!dataPoints[i] || !dataPoints[i + 1]) return NaN;


    // Interpolate Y value at X coordinate
    const interpolatedY = interpolate(
        dataPoints[i].x,
        dataPoints[i].y,
        dataPoints[i + 1].x,
        dataPoints[i + 1].y,
        x
    );

    return interpolatedY;
}


// Function to determine risk zone based on Butani curve
export function getRiskZone(ageInHours: number, bilirubin: number, hasRisk: boolean, shouldUsePhototherapy: boolean): RiskZoneResult {
    const p40AtAge = getYOnCurveByX(percentile40DataPoints, ageInHours);
    const p75AtAge = getYOnCurveByX(percentile75DataPoints, ageInHours);
    const p95AtAge = getYOnCurveByX(percentile95DataPoints, ageInHours);

    let riskZone = -1;
    let percentileString = '';

    if (isNaN(p40AtAge) || isNaN(p75AtAge) || isNaN(p95AtAge)) {
         // Handle cases where interpolation failed (e.g., age < 12)
         percentileString = 'לא ניתן לקבוע אחוזון (גיל < 12 שעות)';
         riskZone = 0; // Or some indicator that it's undefined for this age
    } else if (bilirubin >= p95AtAge) {
        riskZone = 1;
        percentileString = 'מעל אחוזון 95';
    } else if (bilirubin >= p75AtAge) { // Implicitly < p95AtAge
        riskZone = 2;
        const percentile = 75 + ((bilirubin - p75AtAge) / (p95AtAge - p75AtAge)) * 20;
        percentileString = `באחוזון ${percentile.toFixed(0)}`;
    } else if (bilirubin >= p40AtAge) { // Implicitly < p75AtAge
        riskZone = 3;
        const percentile = 40 + ((bilirubin - p40AtAge) / (p75AtAge - p40AtAge)) * 35;
        percentileString = `באחוזון ${percentile.toFixed(0)}`;
    } else { // bilirubin < p40AtAge
        riskZone = 4;
        percentileString = 'מתחת לאחוזון 40';
    }

    const explanation = getTrackingStatusByRiskZone(riskZone, hasRisk, shouldUsePhototherapy);
    return { riskZone, percentileString, explanation };
}

// Function to determine tracking status message
function getTrackingStatusByRiskZone(riskZone: number, hasRisk: boolean, shouldUsePhototherapy: boolean): string {
    // "win" each case.
    if (shouldUsePhototherapy) {
        return 'טיפול אור באשפוז';
    }
    if (riskZone === 0) { // Handle the undefined case from getRiskZone
        return 'מעקב לפי גיל ורמת בילירובין';
    }
    if ((riskZone === 1) || (riskZone === 2 && hasRisk)) {
        return 'המשך אשפוז עם מעקב בילירובין בסרום כל 8 שעות';
    }
    if (riskZone === 2 && !hasRisk) {
        return 'שחרור עם מעקב בילירובין חוזר תוך 24 שעות';
    }
    if (riskZone === 4 || (!hasRisk && riskZone === 3)) {
        return 'שחרור למעקב שגרתי בקהילה, רופא מטפל וטיפת חלב';
    }
    if (hasRisk && riskZone === 3) {
        return 'שחרור עם המלצה למעקב בילירובין חוזר, מלעורי או בסרום, תוך 48 שעות';
    }
    return ''; // Default case, should not happen if logic is correct
}


// Function to determine if phototherapy is needed
export function shouldUsePhototherapy(ageInHours: number, bilirubin: number, isWeek38Plus: boolean, hasRisk: boolean): PhototherapyResult {
    let threshold: number;
    if (ageInHours < 6) {
        threshold = ageInHours / 2;
    } else {
        const dataPoints = getPhototherapyDataPointsByCase(isWeek38Plus, hasRisk);
        threshold = getYOnCurveByX(dataPoints, ageInHours);
    }

    if (isNaN(threshold)) {
        // Handle cases where threshold couldn't be determined (e.g., age too low for curve)
        return { shouldUse: false, delta: NaN };
    }

    const shouldUse = bilirubin >= threshold;
    const delta = Math.abs(bilirubin - threshold); // Calculate difference
    return { shouldUse, delta };
}

// Function to determine transfusion recommendation message
export function gerTransfusionResult(ageInHours: number, bilirubin: number, isWeek38Plus: boolean, hasRisk: boolean): string {
    if (ageInHours < 6 && bilirubin > ageInHours) { // Check bilirubin > ageInHours specifically for < 6 hours
        return 'עובר את סף החלפת דם (בילירובין גדול מגיל הילד)';
    }

    const DELTA_FROM_THRESHOLD_TO_NOTIFY = 2;
    const dataPoints = getTransfusionDataPointsByCase(isWeek38Plus, hasRisk);
    const threshold = getYOnCurveByX(dataPoints, ageInHours);

     if (isNaN(threshold)) {
        // Handle cases where threshold couldn't be determined
        return ''; // Or some other indicator
    }


    if (bilirubin >= threshold) {
        return 'עובר את סף החלפת דם';
    }

    if ((threshold - bilirubin) <= DELTA_FROM_THRESHOLD_TO_NOTIFY) {
        if (hasRisk) {
            return 'ערך בילירובין מתקרב לסף החלפת דם, יש לשקול מתן IVIG';
        } else {
            return 'ערך בילירובין מתקרב לסף החלפת דם';
        }
    }
    return '';
}

// Note: Chart creation functions (createButaniChart, createphototherapyChart, drawPhototherapyWithPoint, drawButaniWithPoint)
// are removed as chart rendering is handled by react-chartjs-2 in the component itself.
